module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTO9jUO5jUe9kUu9lUO5jUe1jUe1jUe9jUO5kUo2blbMAAAAJdFJOUwBT4HAw0KCQb1IObv4AAACCSURBVBjTY2DAC8QipybC2EIzgUARwmafqezAYjSzAMypnAwiLaeDSMaZDiCKZaYAkGQCSnBOAEopADmSChAO00QgJ9MAYg7zNCAR6QDhsEwFEjMZIMrADBQOSBmIA1YGMgDEARuAYjSKpSjOYaicgXAo0AsaDixNUC+geA7V29gBAA/WIwXJFpthAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/info_black_24dp.png
// module id = 47
// module chunks = 0